const [ w, d ] = [ window, document ]

const init = () => {

  Promise.all( [ w.load['header'] ] ).then( () => {
    $('.p-gnav__item.is-translation').currentMenu({mode:0,default:999});
  })

}

export default function ABOUTUS() {
  $( init )
}